import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GtmService } from '../../../../../shared/cardholders-core/services/gtm.service';
import { ModalService } from '../../../../../shared/modules/bs-modal/services/modal.service';
import { IStandingOrderData } from '../../../interfaces/ICheckForCardResponse.interface';
import { UiHelperService } from '../../../../../shared/cardholders-core/services/ui-helper.service';

@Component({
    selector: 'app-success-popup',
    templateUrl: './success-popup.component.html',
    styleUrls: ['./success-popup.component.scss']
})
export class SuccessPopupComponent implements OnInit {
    @Input() transactions: IStandingOrderData[] = [];
    @Input() successCount: number;
    @Input() total: number;
    @Input() subTitle: string;
    @Input() subTitleMobile: string;
    isMobile: boolean;

    constructor(
        private modalSvc: ModalService,
        public bsModalRef: BsModalRef,
        private gtmService: GtmService,
        private uiHelper: UiHelperService
    ) {}

    ngOnInit(): void {
        this.isMobile = this.uiHelper.IsMobile();
        this.gtmService.pushDirectDebit('part success - detail', 'load');
    }

    close(): void {
        this.modalSvc.closeModal();
    }
    getSymbol(curency: number): string {
        switch (curency) {
            case 0:
            case 376:
                return '₪';
            case 840:
                return '$';
            case 978:
                return '€';
            default:
                return '₪';
        }
    }
    textTooltip(transaction: IStandingOrderData): string {
        return `זה הטלפון של בית העסק שאנחנו מכירים
        ${transaction.merchantPhone}`;
    }

    transferDirectDebits(): void {
        this.gtmService.pushDirectDebit('part success - detail', 'ok');
        this.modalSvc.closeModalAndAlertSubscribers(this.transactions.filter((x) => x.isChecked === true));
    }
}
